import React from 'react';
import { KatButton, KatLabel } from '@amzn/katal-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { EventHandler } from '../../utils/customEventHandler'

import '../App.scss';

export class ApiResponse extends React.Component {

    state = {
        status: '',
        requestId: '',
        responseBody: ''
    }

    handleEvent = (event) => {
        this.setState({
            status: event.detail.status,
            requestId: event.detail.requestId,
            responseBody: event.detail.responseBody
        });
    };

    componentDidMount() {
        EventHandler.subscribe('apiEvent', this.handleEvent);
    }

    componentWillUnmount() {
        EventHandler.unsubscribe('apiEvent', this.handleEvent);
    }

    render() {
        return (
            <div>

                <KatLabel
                    emphasis="Status Code"
                    tooltipText="Any 2xx response (200, 201, etc.) is considered a successful API call. 4xx is a user issue. 5xx is an Amazon Pay system issue."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.status}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.status}</pre>

                <KatLabel
                    emphasis="Request ID"
                    tooltipText="Value of the x-amz-pay-request-id Response Header. If you have concerns that the API is not handling the operation as expected, you can supply the Request ID to Amazon Pay support representatives to help our engineers find the exact request in the system logs."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.requestId}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.requestId}</pre>

                <KatLabel
                    emphasis="Response Body"
                    tooltipText="JSON response from the API all. The Scratchpad pretty-prints the JSON for readability."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.responseBody}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.responseBody}</pre>

            </div>
        );
    }
}

export default ApiResponse;
